// @flow
import * as React from 'react';

type Props = {
  children: React.Node,
};

const Hint = ({ children }: Props) => {
  return <div className="ds-c-field__hint">{children}</div>;
};

export default Hint;
